import { appstr } from "../utils/appstr";
import { appstrp } from "../utils/appstrp";
import { enumElementBorderStyle } from "../constants";
import { QAlert } from "./QAlert";
import { QTextEdit } from "./QTextEdit";
import { QCmd } from "./QCmd.js";
import { Globals } from "./Globals";

export class QViewerTextEdit extends QTextEdit {
  constructor() {
    super();
  }

  InitTextEdit(
    panel,
    xPos,
    yPos,
    width,
    height,
    blankMsg,
    maxLen,
    tabID,
    addBorderLine,
    addExpander
  ) {
    this.SetEnabled(true);
    this.SetIsControl(true);
    this.SetIsSelectable(false);

    this.SetWantsKeyboardInput(true);
    this.InitTextEditBase();

    this.SetDblClickCmd("TESelectAll");

    this.PositionElement(xPos, yPos);
    this.SizeElement(width, height);
    this.SetResizeBehavior(true, true, false, false);
    this.SetBlankMessage(blankMsg);
    this.SetMaxLen(maxLen);

    this.TESetVAlignment("middle");
    var teFill = Globals._themeMode.textedit.fill;
    var textColor = Globals._themeMode.text.header;
    this.SetFillColor(teFill);
    this.SetFontColor(textColor);
    if (tabID != -1) {
      this.SetTabID(tabID);
      panel.AddToTabList(this);
    }

    this.SetBorderStyle(enumElementBorderStyle.roundBorder);
    this.SetBorderRadius(2);
    this.SetBorderThickness(1);
    this.SetBorderColor(Globals._themeMode.button.border);

    panel.PushElement(this);

    if (addExpander) {
      this.AddMoreTextButton(panel.fWSMgr);
    }

    return this;
  }

  RenderShadowAndBorder(drawBuffer) {
    if (this.GetShadowOn()) this.DoRenderShadow(drawBuffer);
    this.DoRenderBorder(drawBuffer);
  }

  SetNumRows(numRows) {
    this.fNumRows = numRows;
    if (this.fNumRows > 1) this.TESetVAlignment("top");
  }

  SetListening(doSet) {
    this.fIsListening = doSet;
  }

  SetCmdCode(cmdCode) {
    this.fTECommandCode = cmdCode;
  }

  DoAfterKeyPress(keyInfo) {
    if (this.fIsListening) {
      var cmdCode = this.fTECommandCode ? this.fTECommandCode : "TEKeyPress";
      this.AddCmdParameter("keyInfo", keyInfo);
      var listenCommand = new QCmd();
      listenCommand.InitCommand(
        cmdCode,
        this,
        this.fParentPanel,
        this.fParentPanel.fWSMgr,
        this.fDoc
      );
      this.SetCmdParameters(listenCommand);
      this.fParentPanel.ExecuteCommand(listenCommand);
    }
  }

  DoCut() {
    if (this.IsContentMasked()) return null;

    var cbBuffer = this.DoCopy();
    this.InsertString("");
    this.DoAfterKeyPress();
    return cbBuffer;
  }

  DoPaste(theBuffer) {
    var theData = theBuffer.trim();
    var didPaste = this.InsertString(theData);
    if (!didPaste) {
      var limitMsg =
        appstrp("Maximum character limit reached", ". ") +
        appstrp("Character length cannot exceed", " ") +
        this.GetMaxLen() +
        ".";
      var overInsertLimitAlert = new QAlert();
      overInsertLimitAlert.InitAlert(
        appstr("Max Char Limit Warning"),
        limitMsg,
        this.fParentPanelRef,
        this.GetWSMgrRef()
      );
    }
    this.DoAfterKeyPress();
  }
}
